/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'glyph/16/check-white': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M12.4 6L11 4.6l-4 4-2-2L3.6 8 7 11.4z" _fill="#fff"/>'
  }
})
